export const TOGGLE_MENU_CONTEXT = 'TOGGLE_MENU_CONTEXT';
export const UPDATE_CURRENT_PATIENT = 'UPDATE_CURRENT_PATIENT';
